var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentPanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 68,
    viewBox: "0 0 61 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 68H56.5V61.25C56.5 59.45 55.78 57.74 54.52 56.48C53.26 55.22 51.55 54.5 49.75 54.5H40.75C38.95 54.5 37.24 55.22 35.98 56.48C34.72 57.74 34 59.45 34 61.25V68H29.5V61.25C29.5 58.28 30.7 55.4 32.8 53.3C34.9 51.2 37.78 50 40.75 50H49.75C52.72 50 55.6 51.2 57.7 53.3C59.8 55.4 61 58.28 61 61.25V68Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 27.5C46.57 27.5 47.89 27.89 49 28.64C50.11 29.39 50.98 30.44 51.49 31.67C52 32.9 52.12 34.25 51.88 35.57C51.61 36.89 50.98 38.09 50.02 39.02C49.09 39.95 47.86 40.61 46.57 40.88C45.25 41.15 43.9 41 42.67 40.49C41.44 39.98 40.39 39.11 39.64 38C38.89 36.89 38.5 35.57 38.5 34.25C38.5 32.45 39.22 30.74 40.48 29.48C41.74 28.22 43.45 27.5 45.25 27.5ZM45.25 23C43.03 23 40.84 23.66 39.01 24.89C37.15 26.12 35.71 27.89 34.87 29.93C34.03 32 33.79 34.25 34.24 36.44C34.66 38.63 35.74 40.64 37.33 42.2C38.89 43.76 40.9 44.84 43.09 45.29C45.28 45.71 47.53 45.5 49.6 44.66C51.67 43.82 53.41 42.38 54.64 40.52C55.87 38.66 56.53 36.5 56.53 34.28C56.53 31.31 55.33 28.43 53.23 26.33C51.13 24.23 48.25 23.03 45.28 23.03L45.25 23Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 0.5H18.25C17.56 0.5 17.11 0.71 16.66 1.16L0.91 16.91C0.46 17.36 0.25 17.81 0.25 18.5V59C0.25 61.46 2.26 63.5 4.75 63.5H25V59H4.75V23H18.25C20.71 23 22.75 20.96 22.75 18.5V5H45.25V18.5H49.75V5C49.75 2.51 47.74 0.5 45.25 0.5ZM18.25 18.5H5.65L18.25 5.9V18.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentPanel);
export default __webpack_public_path__ + "static/media/ic-document-panel.64477f6b2c876611ac114e7828373650.svg";
export { ForwardRef as ReactComponent };